import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { push } from "store/actions/router";
import ProfileInfoCard from "./ProfileInfoCard";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { createErrorSelector, createLoadingSelector } from "store/selectors";
import { accountConstants, userConstants } from "actions/types";
import { updateUserProfile } from "actions/userActions";
import type { RootState } from "types/state";

import Button from "components/Button";
import UserProfileWorkflow from "pages/dashboards/individualDashboard/profile/UserProfileWorkflow";

import "./ProfileInfo.scss";

interface OwnProps {
  fetchingProfile?: boolean;
}

const profileUpdateSelector = createLoadingSelector(
  userConstants.USER_PROFILE_UPDATE,
  // PRESERVED BUG (conversion-only): createLoadingSelector takes a single
  // string | string[]; this extra arg is silently ignored. Use an array to
  // actually include GET_ACCOUNTS — left as-is to avoid behavior change.
  // @ts-expect-error preserved multi-argument selector bug
  accountConstants.GET_ACCOUNTS
);
const profileUpdateErrorSelector = createErrorSelector(
  userConstants.USER_PROFILE_UPDATE,
  // PRESERVED BUG (conversion-only): createErrorSelector takes a single
  // string | string[]; this extra arg is silently ignored. Use an array to
  // actually include GET_ACCOUNTS — left as-is to avoid behavior change.
  // @ts-expect-error preserved multi-argument selector bug
  accountConstants.GET_ACCOUNTS
);
const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
  const { id, profile: userInfo } = state.user;
  const iraAccounts = state.accounts.iraAccounts;

  return {
    id,
    userInfo,
    ownProps,
    isUpdatingProfile: profileUpdateSelector(state),
    error: profileUpdateErrorSelector(state),
    iraAccounts,
  };
};

const mapDispatchToProps = { push, updateUserProfile };

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

interface State {
  isEditMode: boolean;
}

class ProfileInfo extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isEditMode: false,
    };
  }

  render() {
    return (
      <div
        className="tab-pane"
        id="account"
        role="tabpanel"
        aria-labelledby="account_tab"
      >
        {!this.state.isEditMode && (
          <>
            <ProfileInfoCard
              userInfo={this.props.userInfo}
              iraAccounts={this.props.iraAccounts}
            />
            <Button
              style={{ marginLeft: 10 }}
              className="edit"
              type="button"
              name="action"
              size="sm"
              withArrow={true}
              btnLabel="Update Info"
              onClick={() => {
                this.setState({ isEditMode: true });
              }}
            />
          </>
        )}
        {!this.props.fetchingProfile && this.state.isEditMode && (
          <UserProfileWorkflow
            onSuccess={() => this.setState({ isEditMode: false })}
            onCancel={() => this.setState({ isEditMode: false })}
          />
        )}
      </div>
    );
  }
}

export default connector(withApollo<Props>(ProfileInfo));
